"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextMultiLineInput = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var models_1 = require("../../../models");
var CharacterLimitNote_1 = require("../CharacterLimitNote");
var ErrorMessage_1 = require("../ErrorMessage");
var PropertyInputWrapper_1 = require("../PropertyInputWrapper");
var TextArea_1 = require("../TextArea");
var TextMultiLineInput = function (_a) {
    var propertyId = _a.propertyId, placeholder = _a.placeholder, onChange = _a.onChange, onBlur = _a.onBlur, text = _a.text, errorMessages = _a.errorMessages, disabled = _a.disabled, className = _a.className, maxLength = _a.maxLength, minLength = _a.minLength, design = _a.design, displayError = _a.displayError;
    var handleChange = function (e) {
        onChange(e.target.value);
    };
    var handleBlur = function (e) {
        if (onBlur) {
            onBlur(e.target.value);
        }
    };
    var displayLimitNote = maxLength != null || minLength != null;
    return (jsx_runtime_1.jsxs(PropertyInputWrapper_1.PropertyInputWrapper, __assign({ propertyId: propertyId, propertyType: models_1.PROPERTY_TYPE.text, inputFormatType: models_1.TEXT_PROPERTY_INPUT_TYPE.multiLine, errorMessages: errorMessages, className: className, displayError: displayError }, { children: [jsx_runtime_1.jsx(TextArea_1.TextArea, { error: displayError, "data-cy-property-item": true, value: text, placeholder: placeholder, onChange: handleChange, onBlur: handleBlur, disabled: disabled, name: propertyId, id: propertyId, "aria-invalid": displayError, "aria-errormessage": ErrorMessage_1.getFieldErrorMessageId(propertyId) }, void 0), displayLimitNote && (jsx_runtime_1.jsx(CharacterLimitNote_1.CharacterLimitNote, { css: { marginTop: '4px' }, color: design.colors.noticeAndGuideFont, maxLength: maxLength, minLength: minLength, value: text }, void 0))] }), void 0));
};
exports.TextMultiLineInput = TextMultiLineInput;
